import React from 'react';
import PropTypes from 'prop-types';

const PlanePlan = (props) => {
  const { children, priceType, className } = props;
  return (
    <div className={`${className} priceText ${priceType}`}>
      {children}
    </div>
  );

};

PlanePlan.defaultProps = {
  priceType: 'blue',
  className: '',
};

PlanePlan.propTypes = {
  priceType: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default PlanePlan;
